import { render } from "./OrdinancePreview.vue?vue&type=template&id=67e530ac"
import script from "./OrdinancePreview.vue?vue&type=script&lang=ts"
export * from "./OrdinancePreview.vue?vue&type=script&lang=ts"
script.render = render

export default script